module.exports = {
	events: {
		showProduct: {
			type: 'click',
			selector: 'table > tbody > tr',
			action: function(event){
				var self = event.data.component;
				var $actionsUsed = $(event.target).closest('td.actions > *');
				if($actionsUsed.length <= 0 || $actionsUsed.hasClass('showEdit_product')){
					event.preventDefault();
					event.stopImmediatePropagation();

					var $target = $(event.target).closest('tr');
					var rowID = $target.data('rowId');
					if(rowID){
						self.showProduct(rowID)
					}
				}
			}
		}
	},

	model: {
		webUrlBase: ''
	},

	methods: {
		prepare(storage){
			this.model.webUrlBase = (((storage || {}).app || {}).webService || {}).url || '';
			if(this.model.webUrlBase){
				this.model.webUrlBase = String(this.model.webUrlBase).replace(/\/+$/, '');
			}
		},

		showProduct(productID){
			return getComponent('ttgShopController').showEdit('product', productID);
		}
	}
}

